module.exports = __webpack_public_path__ + "static/instagram-6f483dac73f74a3eddb8b57f98123139.png";